export default {
  computed: {
    augmentedAssignments: {
      cache: true,
      get() {
        const assignments = _.cloneDeep(this.assignments);
        assignments.map((a) => this.addMembersToAssignment(a));
        return assignments;
      }
    },
    augmentedMembers: {
      cache: true,
      get() {
        let augmentedMembers = {};
        const groups = this.managedGroups;
        groups.forEach((g) => {
          augmentedMembers[g.groupId] = this.getAugmentedMembersForGroup(g.groupId);
        });
        return augmentedMembers;
      }
    },
    augmentedRecordings: {
      cache: true,
      get() {
        const feedback = this._.cloneDeep(this.$store.getters.feedback);
        const groups = this.$store.getters.activeGroupsById;
        const recs = [];

        this._.forEach(this.recordings, (r) => {
          const recording = this._.cloneDeep(r);
          recording.groupName = groups[recording.groupId].name;

          // Find the assignment
          this._.forEach(this.assignments, (ass) => {
            if (ass.recordings && ass.recordings.length) {
              const located = this._.find(ass.recordings, (r) => r.recordingId === recording.recordingId);
              if (located) {
                recording.assignment = ass;
              }
            }
          });

          recording.feedbackCount = 0;
          this.coreScoresByApiName.forEach((rating) => {
            recording[rating + 'AvgRating'] = 0;
            recording[rating + 'AvgRatingCoach'] = 0;
            recording['numRatings' + rating] = 0;
            recording['numCoachRatings' + rating] = 0;
          });

          if (feedback && feedback[recording.recordingId] && feedback[recording.recordingId].length) {
            recording.feedback = feedback[recording.recordingId];

            recording.feedback.forEach((f) => {
              if (f.comment) {
                recording.feedbackCount++;
              }
              if (f.scoreOverall !== undefined) {
                this.coreScoresByApiName.forEach((rating) => {
                  if (!f[rating]) return;

                  recording['numRatings' + rating] = (recording['numRatings' + rating]) ?
                    recording['numRatings' + rating] + 1 : 1;
                  recording[rating + 'AvgRating'] += f[rating];

                  if (f.isManager) {
                    recording['numCoachRatings' + rating] = (recording['numCoachRatings' + rating]) ?
                      recording['numCoachRatings' + rating] + 1 : 1;
                    recording[rating + 'AvgRatingCoach'] += f[rating];
                  }
                });
              }
            });
            // TODO: Add support for custom ratings
            this.coreScoresByApiName.forEach((rating) => {
              recording[rating + 'AvgRating'] = (recording['numRatings' + rating] > 0) ? _.round(recording[rating + 'AvgRating']/recording['numRatings' + rating], 2) : 0;
              recording[rating + 'AvgRatingCoach'] = (recording['numCoachRatings' + rating] > 0) ? _.round(recording[rating + 'AvgRatingCoach']/recording['numCoachRatings' + rating], 2) : 0;
            });
          }

          recs.push(recording);
        });
        return recs;
      }
    },
  },
  methods: {
    getAssignmentSavePromises(targets, targetType='group', modifiers= {}) {
      let scorecard = this.assignment.scorecard ? this.assignment.scorecard : null;

      let assignment = _.cloneDeep(this.assignment);
      assignment.userTargets = [];
      assignment.groupTargets = [];
      if (targets && targetType) {
        assignment[targetType + 'Targets'] = targets;
      }

      assignment = _.assign(assignment, modifiers);
      delete assignment.assignmentId;

      // Update the Coach Dashboard preferences so we see the new assignment
      if (assignment.groupId) {
        this.$store.dispatch(
          'updatePreferences',
          Object.assign(
            this.preferences,
            {coachDashboardToggle: 'assignments', selectedGroup: assignment.groupId}
          )
        );

        // We always clone the template and then assign to the copy
        assignment.assignmentTemplateId = assignment.assignmentId;
        assignment.isTemplate = false;
        assignment.isShared = true;
      }

      // First we make a new assignment, then we update it
      return this.$store.dispatch(
        'addAssignment',
        { assignment }
      ).then((_assignment) => {
        assignment.assignmentId = _assignment.assignmentId;

        // Set up attachments for saving
        let newAttachments = assignment.attachments;
        assignment.attachments = [];

        const promises = [
          // Update with targets, attachments and other stuff
          this.$store.dispatch(
            'updateAssignment',
            { assignment, newAttachments, updateTargets: true }
          ),
        ];

        // Clone and assign the scorecard
        if (scorecard) {
          delete scorecard.id; // We need to make a new scorecard, not reuse this one
          if (_assignment.groupId) {
            scorecard.groupId = _assignment.groupId;
          }
          scorecard.assignmentId = _assignment.assignmentId;
          promises.push(this.$store.dispatch(
            'saveAssignmentScorecard',
            {assignment, scorecard}
          ));
        }

        // Update Wordspotting
        if (assignment.wordspotting && assignment.wordspotting.length) {
          promises.push(
            this.$store.dispatch(
              'updateAssignment',
              { assignment, updateWordspotting: true }
            )
          );
        }
        return window.Promise.all(promises);
      }).catch(() => {
        this.saving = false;
      });
    },
    getAugmentedMembersForGroup(groupId) {
      let members = _.cloneDeep(this.$store.getters.groupMembers[groupId]);

      // Iterate assignments and add them to each member
      this._.forEach(members, (member) => {
        member.assignments = [];
        // Only look at assignments tied to the current group
        this._.forEach(this._.filter(this.augmentedAssignments, (a) => a.groupId == groupId), (assignment) => {
          if (assignment.userTargets && assignment.userTargets.length) {
            this._.forEach(assignment.userTargets, (ut) => {
              if (ut.userId == member.userId) {
                const ass = _.cloneDeep(assignment);
                // before assigning properties from user target to assignment, remove user target .name prop
                delete ut.name;
                Object.assign(ass, ut);

                // Find and link in their recordings
                const am = _.find(ass.members, (m) => m.userId == member.userId);
                if (!am) return;

                ass.recordings = this._.filter(am.recordings, r => !r.deleted);
                // Sort the user's recordings for this assignment by date
                ass.recordings = _.sortBy(ass.recordings, r => -new Date(r.createdDate).getTime());
                // get rid of other users attached to this assignment
                delete ass.members;

                // build stats by iterating over user's recordings for this assignment
                // Some stats are attached directly to each recording. Other stats are kicked up to assignment.
                ass.feedbackCount = 0;
                let totalRating = 0;
                let numRatings = 0;
                ass.totalLength = 0;
                let totalScore = 0;
                let numRecordingsWithScore = 0;

                this._.forEach(ass.recordings, (r) => {
                  r.overallScore = (r.results && r.results.scores && r.results.scores.overall) ? r.results.scores.overall : 'N/A';
                  r.sharedWithCount = (r.feedbackRequested) ? _.max([0, assignment.userTargets.length - 1]) : 0;
                  if (r.duration === undefined) {
                    r.duration = 0;
                  }

                  // Zero out the stats so we don't overcount if run twice
                  this.coreScoresByApiName.forEach((rating) => {
                    r[rating + 'AvgRating'] = 0;
                    r[rating + 'AvgRatingCoach'] = 0;
                    r['numRatings' + rating] = 0;
                    r['numCoachRatings' + rating] = 0;
                  });

                  r.numComments = 0;
                  if (r.feedback && r.feedback.length) {
                    this._.forEach(r.feedback, (f) => {
                      if (f.comment) {
                        r.numComments++;
                      }
                      if (f.scoreOverall !== undefined) {
                        this.coreScoresByApiName.forEach((rating) => {
                          if (!f[rating]) return;

                          r['numRatings' + rating] = (r['numRatings' + rating]) ?
                            r['numRatings' + rating] + 1 : 1;
                          r[rating + 'AvgRating'] += f[rating];

                          if (f.isManager) {
                            r['numCoachRatings' + rating] = (r['numCoachRatings' + rating]) ?
                              r['numCoachRatings' + rating] + 1 : 1;
                            r[rating + 'AvgRatingCoach'] += f[rating];
                          }
                        });

                        totalRating += f.scoreOverall;
                        numRatings++;
                      }
                    });
                  }

                  // TODO: Add support for custom ratings
                  this.coreScoresByApiName.forEach((rating) => {
                    r[rating + 'AvgRating'] = (r['numRatings' + rating] > 0) ? _.round(r[rating + 'AvgRating']/r['numRatings' + rating], 2) : 0;
                    r[rating + 'AvgRatingCoach'] = (r['numCoachRatings' + rating] > 0) ? _.round(r[rating + 'AvgRatingCoach']/r['numCoachRatings' + rating], 2) : 0;
                  });

                  ass.feedbackCount += r.numComments;
                  ass.totalLength += r.duration;

                  if (r.results && r.results.scores && r.results.scores.overall) {
                    totalScore += r.results.scores.overall;
                    numRecordingsWithScore++;
                  }
                });

                // attach stats to assignment
                ass.sharedWithCount = 0;
                if (_.find(ass.recordings, r => r.feedbackRequested)) {
                  ass.sharedWithCount = _.max([ass.userTargets.length - 1, 0] );
                }

                ass.scoreOverallAvgRating = (numRatings > 0) ? _.round(totalRating/numRatings, 2) : 'N/A';
                ass.overallScore = (numRecordingsWithScore > 0) ? _.round(totalScore/numRecordingsWithScore, 2) : 'N/A';
                ass.numSubmittedRecordings = _.filter(ass.recordings, r => r.submitted).length;
                member.assignments.push(ass);
              }
            });
          }
        }); // Finished building assignments list for user

        // compile some stats for user's recordings across all assignments
        // This is a list of all user's recordings without regard for which assignment attached to
        const flattenedRecordings = _.flatMap(member.assignments, a => a.recordings);

        member.totalActiveAssignments = _.sumBy(member.assignments, a => (a.completionStatus.status !== 'completed' && a.archived !== true) ? 1 : 0);
        member.totalRecordings = flattenedRecordings.length;
        member.totalLength = _.sumBy(flattenedRecordings, r => r.duration);
        member.lastRecordingDate = _.max(_.map(flattenedRecordings, r => new Date(r.createdDate).getTime()));
        member.totalFeedback = _.sumBy(member.assignments, a => a.feedbackCount);
        member.totalSharedRecordings = _.sumBy(flattenedRecordings, r => r.feedbackRequested ? 1 : 0);
        member.totalSubmittedRecordings = _.sumBy(flattenedRecordings, r => r.submitted ? 1 : 0);
      });

      return members;
    },
    addMembersToAssignment(assignment) {
      const feedback = this._.cloneDeep(this.$store.getters.feedback);
      assignment.feedbackCount = 0;

      let members = (assignment.groupId) ?
        _.cloneDeep(this.$store.getters.groupMembers[assignment.groupId]) :
        [];

      // Zero out the recordings for each user to prevent weird
      // issues where recordings get listed twice
      this._.forEach(members, (u) =>  {
        u.recordings = [];
        u.sharedRecordings = 0;
        u.submittedRecordings = 0;
        u.feedbackCount = 0;
      });

      this._.forEach(assignment.recordings, (recording) => {
        if (!members[recording.userId]) return;

        // Augment it with the extra stuff from groupRecordings
        const grForUser = (assignment.groupId && this.$store.getters.groupRecordings[assignment.groupId]) ?
          this.$store.getters.groupRecordings[assignment.groupId][recording.userId] :
          [];
        if (grForUser && grForUser.length) {
          const fullRecording = _.find(grForUser, (r) => {
            return r.recordingId === recording.recordingId;
          });
          if (fullRecording) {
            // Combine the full recording with the version from the assignment
            Object.assign(recording, fullRecording);

            // Update lastUpload for the member
            if (!members[recording.userId].lastUpload ||
              (new Date(recording.createdDate) > new Date(members[recording.userId].lastUpload))) {
              members[recording.userId].lastUpload = recording.createdDate;
            }
          }

          recording.feedbackCount = 0;
          this.coreScoresByApiName.forEach((rating) => {
            recording[rating + 'AvgRating'] = 0;
            recording[rating + 'AvgRatingCoach'] = 0;
            recording['numRatings' + rating] = 0;
            recording['numCoachRatings' + rating] = 0;
          });

          if (feedback && feedback[recording.recordingId] && feedback[recording.recordingId].length) {
            recording.feedback = feedback[recording.recordingId];
            feedback[recording.recordingId].forEach((f) => {
              if (f.comment) {
                recording.feedbackCount++;
                assignment.feedbackCount++;
                members[recording.userId].feedbackCount++;
              }
              this.coreScoresByApiName.forEach((rating) => {
                if (!f[rating]) return;

                recording['numRatings' + rating] = (recording['numRatings' + rating]) ?
                  recording['numRatings' + rating] + 1 : 1;
                recording[rating + 'AvgRating'] += f[rating];

                if (f.isManager) {
                  recording['numCoachRatings' + rating] = (recording['numCoachRatings' + rating]) ?
                    recording['numCoachRatings' + rating] + 1 : 1;
                  recording[rating + 'AvgRatingCoach'] += f[rating];
                }
              });
            });

            this.coreScoresByApiName.forEach((rating) => {
              recording[rating + 'AvgRating'] = (recording['numRatings' + rating] > 0) ? _.round(recording[rating + 'AvgRating']/recording['numRatings' + rating], 2) : 0;
              recording[rating + 'AvgRatingCoach'] = (recording['numCoachRatings' + rating] > 0) ? _.round(recording[rating + 'AvgRatingCoach']/recording['numCoachRatings' + rating], 2) : 0;
            });

            if (assignment.scorecard) {
              const allScores = this.getScorecardQuestionsForRecording(recording, assignment.scorecard);
              allScores.forEach((_score) => {
                if (_score.preset) return;

                recording[_score.id + 'AvgRating'] = _score.avgScore || 0;
                recording[_score.id + 'AvgRatingCoach'] = _score.mgrAvgScore || 0;
                recording['numRatings' + _score.id] = _score.responses ? _score.responses.length : 0;
                recording['numCoachRatings' + _score.id] = _score.mgrResponses ? _score.mgrResponses.length : 0;
              });
            }
          }
        }

        if (recording.submitted) {
          members[recording.userId].submittedRecordings++;
        }
        if (recording.feedbackRequested) {
          members[recording.userId].sharedRecordings++;
        }
        members[recording.userId].recordings.push(recording);
      });

      assignment.assignmentAssignedCount = assignment.userTargets.length;
      assignment.assignmentCompletedCount = 0;
      assignment.assignmentInProgressCount = 0;
      assignment.assignmentNotStartedCount = 0;
      assignment.assignmentForReviewCount = 0;

      this._.forEach(assignment.userTargets, (ut) => {
        // Skip inactive users
        if (!members[ut.userId]) {
          assignment.assignmentCount--;
          return;
        }

        if (ut.completionStatus.status === 'completed') {
          assignment.assignmentCompletedCount++;
        }
        if (ut.completionStatus.status === 'in progress') {
          assignment.assignmentInProgressCount++;
        }
        if (ut.completionStatus.status === 'assigned') {
          assignment.assignmentNotStartedCount++;
        }

        // Combine the full user details with the user from the assignment
        Object.assign(members[ut.userId], ut);
      });

      // Finally, filter out the users we don't want
      // TODO: May no longer be needed now that this is in the API
      members = this._.filter(members, (u) => {
        return (
          u.roles.indexOf('speaker') !== -1 &&
          u.membershipStatus === 'active' &&
          typeof u.completionStatus !== 'undefined'
        );
      });

      // Lastly, iterate assignmentForReviewCount
      this._.forEach(members, (user) => {
        if (user.recordings && user.recordings.length) {
          user.recordings.forEach((r) => {
            if (r.submitted && r.assignmentId === assignment.assignmentId) {
              assignment.assignmentForReviewCount++;
            }
          });
        }
      });
      assignment.members = this.addAssignmentStatsToMembers(members, assignment);
    },

    getAssignmentScoresetForMember(member, scoreType, assignment) {
      // Initialize our stats
      let score = {scoreCounts: 0};
      const scores = [
        'strengthOfOpening',
        'overall',
        'clarity',
        'captivating',
        'confident',
        'authentic',
        'boring',
        'arrogant',
      ];
      scores.forEach((_score) => {
        score[_score] = 0;
        score[_score + 'Max'] = 0;
      });

      // Ratings
      const ratings = this._.clone(this.coreScoresByApiName);

      // Add in custom ratings from the scorecard
      if (assignment && assignment.scorecard && assignment.scorecard.scorecard) {
        assignment.scorecard.scorecard.questions.forEach((_rating) => {
          if (!_rating.preset) {
            ratings.push(_rating.id);
          }
        });
      }

      ratings.forEach((_rating) => {
        score[_rating] = 0;
        score[_rating + 'Coach'] = 0;
        ratings.push(_rating + 'Coach');
      });

      member.recordings.forEach((rec) => {
        // Filter recordings based on scoreType
        if ((scoreType === 'flaggedScores' && !rec.submitted) ||
          (scoreType === 'sharedScores' && !rec.feedbackRequested)) {
          return true;
        }

        ratings.forEach((_score) => {
          const currScore = rec[_score + 'AvgRating'];
          const currCoachScore = rec[_score + 'AvgRatingCoach'];

          if (currScore > score[_score]) {
            score[_score] = currScore;
          }
          if (currCoachScore > score[_score + 'Coach']) {
            score[_score + 'Coach'] = currCoachScore;
          }
        });

        if (rec.results && rec.results.scores && rec.results.scores.vibes) {
          score.scoreCounts++;
          scores.forEach((_score) => {
            const scoreVal = (_score in rec.results.scores.vibes) ?
              rec.results.scores.vibes[_score] :
              rec.results.scores[_score];
            score[_score] += scoreVal;
            if (score[_score + 'Max'] < scoreVal) {
              score[_score + 'Max'] = scoreVal;
            }
          });
        }
      });

      if (score.scoreCounts > 1) {
        scores.forEach((_score) => {
          score[_score] = this._.round(score[_score] / score.scoreCounts, 2);
        });
      }
      return score;
    },

    addAssignmentStatsToMembers(members, assignment) {
      const scoreSets = ['scores', 'flaggedScores', 'sharedScores'];

      members.forEach((member) => {
        scoreSets.forEach((scoreSet) => {
          const _scoreSet = this.getAssignmentScoresetForMember(member, scoreSet, assignment);
          member[scoreSet] = _scoreSet;
        });
      });

      return members;
    },
    loadAllAssignmentsData(isManager) {
      const lookups = [
        this.$store.dispatch('listGroupMembers'),
        this.$store.dispatch(isManager ? 'listAssignments' : 'getAssignedAssignments'),
        this.$store.dispatch('listGroupFeedback'),
      ];
      if (!isManager) {
        lookups.push(this.$store.dispatch('listRecordings'));
      }
      const groups = this[isManager ? 'managedGroups' : 'speakerGroups'];
      groups.forEach((g) => lookups.push(this.$store.dispatch('listGroupRecordings', {groupId: g.groupId})));

      return window.Promise.all(lookups);
    }
  }
};
